import { alpha } from '@mui/material'
import React, { type ReactElement } from 'react'

import Divider from '@mui/material/Divider'
import Popover from '@mui/material/Popover'
import Stack from '@mui/material/Stack'
import { styled, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import type { KNDetailsPopoverProps } from './types'

const StyledPopover = styled(Popover)(({ theme }) => ({
  '.MuiPopover-paper': {
    color: 'white',
    backgroundColor: alpha(theme.palette.primary.dark, 0.85),
    backdropFilter: 'blur(3px)',
    border: 0,
  },
}))

const KNDetailsPopover = ({
  children,
  open,
  onClose,
  anchorEl,
  rightAligned,
  sx,
}: KNDetailsPopoverProps): ReactElement => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  const handleClose = (): void => {
    onClose()
  }

  return (
    <StyledPopover
      open={open}
      anchorEl={anchorEl}
      onClick={handleClick}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: rightAligned ? 'right' : 'left',
      }}
      transformOrigin={{
        vertical: -4,
        horizontal: rightAligned ? 'right' : 'left',
      }}
    >
      <Stack
        data-test="info-details"
        direction="column"
        divider={<Divider orientation="horizontal" flexItem sx={{ borderColor: 'primary.light' }} />}
        sx={{
          minWidth: '16rem',
          maxWidth: isMobile ? '20rem' : '32rem',
          maxHeight: isMobile ? '20rem' : '32rem',
          ...sx,
        }}
      >
        {children}
      </Stack>
    </StyledPopover>
  )
}

export default KNDetailsPopover
